module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/region/region.html
// module id = 609
// module chunks = 0